import { useState } from 'react';
import { TextField, Button, Popover } from '@mui/material';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { DayPicker } from "react-day-picker";
import "react-day-picker/style.css";
import moment from 'moment';

export default function DateRange({range, setRange}) {
	const [dateRange, setDateRange] = useState({from: moment().startOf('month'), to: moment()});
	const [anchorEl, setAnchorEl] = useState(null);

	const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
	
	const handleOpenDate = (event) => {
    setAnchorEl(event.currentTarget);
  };
	const handleCloseDate = () => {
    setAnchorEl(null);
    setRange(dateRange);
  };

	const onSelectRange=()=>{
		setDateRange(range);
		setAnchorEl(null);
	}

	return(
		<div>
			<div style={{float: 'left'}}>
				<TextField size="small" style={{float: 'left'}} sx={{'& .MuiInputBase-root': {paddingRight: '11px'}, '& .MuiInputBase-input': {width: '190px'}}}
					value={`${range && range.from?moment(range.from).format('DD/MM/YYYY'):''} - ${range && range.to?moment(range.to).format('DD/MM/YYYY'):''}`}
					slotProps={{
						input: {
							endAdornment: (
								<Button aria-describedby={id} variant="contained" onClick={handleOpenDate} color="primary"
									size='small' style={{height: '20px', width: '20px', minWidth: '20px'}}>
									<DateRangeIcon />
								</Button>
							),
							readOnly: true,
						},
					}}
				/>
			</div>
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleCloseDate}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
			>
				<div style={{padding: '5px 10px 10px 10px'}}>
					<DayPicker mode="range" selected={range} onSelect={setRange}
					footer={
						<div style={{float: 'right'}}>
							<Button onClick={()=>setRange(null)}>Clear</Button>
							<Button onClick={handleCloseDate}>Cancel</Button>
							<Button onClick={onSelectRange}>Ok</Button>
						</div>
					} />
				</div>
			</Popover>
		</div>
	)
}